import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import type { GameClientControls } from "@rosette/ts/src/business/GameClientControls.js";
import type { GameSource } from "@rosette/ts/src/business/game/controller/source/GameSource.js";


export const GameSourceContext = createContext<GameSource | null>(null);

export function useGameSource(): GameSource {
    const gameSource = useContext(GameSourceContext);
    if (gameSource === null)
        throw new Error("Game setup settings are unavailable!");

    return gameSource;
}


export const GameClientControlsContext = createContext<GameClientControls | null>(null);

export function useGameClientControls(): GameClientControls {
    const controls = useContext(GameClientControlsContext);
    if (controls === null)
        throw new Error("Game client controls are unavailable!");

    return controls;
}


export interface GameContextProviderProps {
    gameSource: GameSource;
    clientControls: GameClientControls;
    children: ReactNode;
}

export function GameContextProvider(
    { gameSource, clientControls, children }: GameContextProviderProps,
) {
    return (
        <GameSourceContext.Provider value={gameSource}>
            <GameClientControlsContext.Provider value={clientControls}>
                {children}
            </GameClientControlsContext.Provider>
        </GameSourceContext.Provider>
    );
}
